import { buttonUrl, isButton } from '@bw/apis/contentful';
import { cn } from '@bw/core';
import { Image } from '@bw/elements';
import Link from 'next/link';
import { annotate } from '../../../utils/annotate';
import { defined } from '../../../utils/defined';
import { ButtonWrapper } from '../../button/ButtonWrapper';
import { HeaderNavItem, isMenu } from '../types';
import styles from './header-desktop-menu.module.scss';

interface DesktopMenuProps {
  activeMenuItem: HeaderNavItem | null;
  onMenuItemClick: () => void;
  onClose: () => void;
}

export const DesktopMenu = ({ activeMenuItem, onMenuItemClick, onClose }: DesktopMenuProps) =>
  isMenu(activeMenuItem) && (
    <div className={styles.megaMenuContainer}>
      <div className={cn(
        styles.menuDesktopBanner,
        !activeMenuItem.fields.hero && activeMenuItem.fields.menuItems.length > 5 && styles.containsDualList
      )}>
        <div className={styles.menuDesktopContentWrapper}>
          <h5 className={styles.menuHeading} {...annotate(activeMenuItem, 'title')}>
            {activeMenuItem.fields.title}
          </h5>
        </div>
        <div>
          <div className={styles.menuDesktopContentWrapper}>
            <div>
              <h5 className={styles.subMenuHeadingSection}>Explore</h5>
              <ul>
                {defined(activeMenuItem.fields.menuItems).map((subMenuItem, index) => (
                  <li
                    key={index}
                    className={styles.menuDesktopContent}
                    data-menu-index={index}
                    {...annotate(subMenuItem)}
                  >
                    <h3>
                      {subMenuItem && isButton(subMenuItem) && (
                        subMenuItem.fields.actionType === 'Navigate' ? (
                          <Link
                            href={buttonUrl(subMenuItem)}
                            onClick={onMenuItemClick}
                          >
                            {subMenuItem.fields.title}
                          </Link>
                        ) : (
                          <ButtonWrapper data={subMenuItem} buttonStyle='link' />
                        )
                      )}
                    </h3>
                  </li>
                ))}
              </ul>
            </div>
            <div className={styles.menuBottomContent}>
              {
                defined(activeMenuItem.fields.actions).map((item, index) => (
                  <h5 key={index} {...annotate(item, '.')}>
                    <Link
                      href={buttonUrl(item)}
                      onClick={onMenuItemClick}
                    >
                      {item.fields.title}
                    </Link>
                  </h5>
                ))
              }
            </div>
          </div>
        </div>
        <div
          {...annotate(activeMenuItem, 'hero')}
          className={styles.menuDesktopImageContent}
          data-aos="zoom-in"
          data-aos-delay="200"
        >
          {activeMenuItem.fields.hero ? (
            <Image
              src={activeMenuItem.fields.hero.fields.file?.url ?? ''}
              alt=''
              width={1000}
              height={1000}
            />
          ) : (
            null
          )}
        </div>
      </div>
      <div className={styles.megaMenuFooter}>
        <button
          onClick={onClose}
          onKeyDown={(e) => {
            // Close the menu on pressing the ESC key
            if (e.key === 'Escape') {
              onClose();
            }
          }}
          title="Close Button"
        >
          Close &nbsp;
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M18 6L6 18M6 6L18 18"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );